import React, { useState } from 'react';
import { CaretDown } from '@phosphor-icons/react';

/**
 * ExpansionPanel - Componente reutilizable para expandir/contraer contenido
 * @param {string} title - Título del panel
 * @param {React.ReactNode} children - Contenido a mostrar cuando está expandido
 * @param {boolean} defaultOpen - Si el panel inicia abierto (default: false)
 * @param {React.ReactNode} icon - Ícono opcional para mostrar junto al título
 * @param {string} className - Clases CSS adicionales para el contenedor
 */
const ExpansionPanel = ({
    title,
    children,
    defaultOpen = false,
    icon = null,
    className = ''
}) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    return (
        <div className={`bg-surface rounded-lg border border-line overflow-hidden ${className}`}>
            {/* Header clickeable */}
            <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                className="w-full px-4 py-3 flex items-center justify-between bg-surface-2 hover:bg-line transition-colors"
            >
                <div className="flex items-center gap-3">
                    {icon && (
                        <span className="text-content-muted">
                            {icon}
                        </span>
                    )}
                    <span className="text-sm font-medium text-content">
                        {title}
                    </span>
                </div>
                <CaretDown
                    size={18}
                    className={`text-content-muted transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
                />
            </button>

            {/* Contenido expandible */}
            <div
                className={`transition-all duration-200 ease-in-out ${isOpen
                        ? 'max-h-[2000px] opacity-100'
                        : 'max-h-0 opacity-0 overflow-hidden'
                    }`}
            >
                <div className="p-4 border-t border-line">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default ExpansionPanel;
